import SimpleStatsCard from '@features/analytics/SimpleStatsCard';

const NumCustomersCard = () => {
  return <SimpleStatsCard label="Customers" val={100} />;
};

export default NumCustomersCard;
